"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryType = void 0;
const table_node_1 = require("./table-node");
/* eslint-disable no-unused-vars */
var QueryType;
(function (QueryType) {
    QueryType["Dim"] = "dim";
    QueryType["DimScaffold"] = "scaffold";
    QueryType["Affiliation"] = "aff";
    QueryType["AffiliationScaffold"] = "aff-scaffold";
})(QueryType = exports.QueryType || (exports.QueryType = {}));
/* eslint-enable no-unused-vars */
const scaffold = '_scaffold';
class BaseQuery {
    static deserialize(obj) {
        let q = new BaseQuery();
        q.queryType = obj.queryType;
        q.tableNodes = obj.tableNodes.map(table_node_1.default.deserialize);
        q.scaffoldField = obj.scaffoldField;
        q.scaffoldType = obj.scaffoldType;
        return q;
    }
    serialize() {
        return {
            queryType: this.queryType,
            tableNodes: this.tableNodes.map(tn => tn.serialize()),
            scaffoldField: this.scaffoldField,
            scaffoldType: this.scaffoldType
        };
    }
    // eslint-disable-next-line no-unused-vars
    forEach(f) {
        this.tableNodes.forEach(node => f(node, this));
    }
    validate(datasetRepo) {
        let valid = this.tableNodes.every(node => !!datasetRepo.datasetByName[node.dataset]);
        if (this.queryType === QueryType.DimScaffold) {
            valid = valid && !!this.scaffoldField;
        }
        return valid;
    }
    lookup(id) {
        if (id.endsWith(scaffold))
            id = id.substring(0, id.length - scaffold.length);
        return this.tableNodes.find(n => n.id === id);
    }
}
exports.default = BaseQuery;
